module.exports = __webpack_public_path__ + "static/media/Play.78394dc9.svg";